import {h, Fragment} from "preact"
import { defaultConfig } from '../config'
import { useAppState, HistoryElement } from '@nosto/preact'

export default () => {
    const { historyItems } = useAppState();
    const suggestions = window.cj?.nosto?.suggestion_links || []; // elements formatted: `url::title`
    const noHistory = (!historyItems || !historyItems.length);
    const noSuggestions = (!suggestions || !suggestions.length);
    const isNewSearchFeatureEnabled = window.cj.nosto.newSearchFeatureEnabled;

    if ((noHistory && noSuggestions) || isNewSearchFeatureEnabled) {
        return
    }
    /*
    const handleRemoveClick = () => {
        setRemoveButtonDisabled(true);
    };
    console.log('==> historyItems', historyItems)
    */
    return (
        <div id="history-items" class="ns-autocomplete  ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-p-4 ns-my-0">
            <div class="ns-w-100 ns-mt-2 ns-mt-sm-auto">
                {noHistory ? null : (
                    <>
                        <div class="ns-color-grey-dark ns-font-medium ns-font-5 subheading">
                            {window.cj?.nosto?.recent_heading || "Recent Searches"}
                        </div>
                        <div>
                            {historyItems
                                ?.slice(0, defaultConfig.historySize)
                                .map((item) => (
                                    <HistoryElement query={{ query: item }}>
                                        <div class="ns-product ns-d-flex flex-row ns-justify-content-between ns-clickable ns-p-2">
                                            <div class="ns-font-4">{item}</div>
                                            {/* <button class="rm_this_item" disabled={removeButtonDisabled}
                                                onClick={handleRemoveClick}>X</button>
                                            */}
                                        </div>
                                    </HistoryElement>
                                ))}
                        </div>
                    </>
                )}
                {noSuggestions ? null : (
                    <>
                        <div class={`ns-color-grey-dark ns-font-medium ns-font-5 subheading ${!noHistory ? 'ns-mt-4' : ''}`}>
                            {window.cj.nosto.suggestion_heading || "Now Trending"}
                        </div>
                        <div>
                            {suggestions
                                ?.slice(0, 10)
                                .map((suggestion) => {
                                    // elements formatted: `url::title`
                                    const [url, title] = (suggestion || "").split('::')
                                    return (
                                        <a href={url}>
                                            <div class="ns-product ns-d-flex flex-row ns-justify-content-between ns-clickable ns-p-2">
                                                <div class="ns-font-4">{title}</div>
                                            </div>
                                        </a>
                                    );
                                })}
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}
